import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { ApiService } from '@lib/services/api.service';
import { MatNotification } from 'src/lib/modules/mat-notifications/mat-notifications.module';
import { AppService } from 'src/lib/services/app.service';

@Injectable({
    providedIn: 'root'
})
export class uiGuard implements CanActivate, CanActivateChild {
	constructor(private title: Title,
				private swUpdate: SwUpdate,
				private notification: MatNotification,
				private apiService: ApiService,
				private appService: AppService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        if(this.apiService.isAuthenticated)
            localStorage.setItem("persistent.redirect.location", state.url);

		if(!route.children.length) {

			/**
			 * Update browser title
			 */
			const title = route.pathFromRoot.filter(({data}) => data?.title).map(({data}) => data.title).unique();
			this.title.setTitle(`Portail${title.length > 0 ? ' - ' : ''}${title.join(' ')}`);

			/**
			 * Close notifications
			 */
			this.notification.closeAll();

			if(this.swUpdate.isEnabled)
				this.swUpdate.checkForUpdate();

			this.appService.onNavigateSubject.next(state);
		}
		
		return  true;
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean { return this.canActivate(route, state); }
}